module.exports = __webpack_public_path__ + "static/media/chat-off.d611a0a5.svg";